module.exports = __webpack_public_path__ + "static/media/header.6d4baf5f.jpg";